import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/surveys/$surveyId/topics/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/app/admin/surveys" />;
}
